import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { environment } from '@src/environments/environment';
import { EnpsComponent } from '@src/suite/common/components/base/enps-component';
import { ErrorLS } from '@src/suite/common/data-models/misc/errors';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { LanguageSettings } from '@src/suite/common/services/language-settings';
import { NavigationService } from '@src/suite/common/services/navigation-service';

@Component({
    selector: 'st-dialog-about',
    imports: [MatButton, MatDialogClose],
    templateUrl: './top-bar-user-menu-dialog-about.html',
    styleUrl: './top-bar-user-menu-dialog-about.scss',
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-dialog-about' },
})
export class TopBarUserMenuDialogAboutComponent extends EnpsComponent implements OnInit {
    dialogRef = inject<MatDialogRef<TopBarUserMenuDialogAboutComponent>>(MatDialogRef);
    languageSettings = inject(LanguageSettings);
    navigationService = inject(NavigationService);
    globalTablesService = inject(GlobalTablesService);

    private warningErrors: ErrorLS[];
    private criticalErrors: ErrorLS[];
    public hasErrors = false;
    public app_version = '';
    ngOnInit(): void {
        if (environment.pst_version) {
            this.app_version = environment.pst_version.toLowerCase();
            this.globalTablesService.AppVersion = this.app_version;
            this.globalTablesService.setPlaybookHelpUrl();
            this.globalTablesService.setEnforceRequiredFieldsOnCreate();
        }
        this.hasErrors = this.checkIsThereErrorLog();
    }

    get productLabel(): string {
        return this.languageSettings.PSTWebApStorytellingLabel;
    }

    public closeDialog() {
        this.dialogRef.close();
    }

    private checkIsThereErrorLog(): boolean {
        let errorsStr = localStorage.getItem('warningErrors');
        if (errorsStr) {
            let errors = [];
            try {
                errors = JSON.parse(errorsStr) as ErrorLS[];
            } catch (err) {
                console.warn(err);
            }
            this.warningErrors = errors;
        }
        errorsStr = localStorage.getItem('criticalErrors');
        if (errorsStr) {
            let errors = [];
            try {
                errors = JSON.parse(errorsStr) as ErrorLS[];
            } catch (err) {
                console.warn(err);
            }
            this.criticalErrors = errors;
        }

        if ((this.warningErrors && this.warningErrors.length > 0) || (this.criticalErrors && this.criticalErrors.length > 0)) {
            return true;
        }
        return false;
    }

    public downloadErrors() {
        let text = '';
        if (this.criticalErrors && this.criticalErrors.length > 0) {
            text += 'CRITICAL:\n\r\n\r';
            for (const error of this.criticalErrors) {
                const msg = error.msg.replace(/[\n\r+]/gi, '');
                text += `[${error.timestamp}] - ${error.type.toUpperCase()} - ${msg}\n\r\n\r`;
            }
        }

        if (this.warningErrors && this.warningErrors.length > 0) {
            if (this.criticalErrors && this.criticalErrors.length > 0) {
                text += '\n\r\n\r------------------------------------------------------------------------------------\n\r\n\r\n\r\n\r';
            }
            text += 'WARNING:\n\r\n\r';
            for (const error of this.warningErrors) {
                const msg = error.msg.replace(/[\n\r+]/gi, '');
                text += `[${error.timestamp}] - ${error.type.toUpperCase()} - ${msg}\n\r\n\r`;
            }
        }

        const data = new Blob([text], { type: 'text/plain' });
        const element: HTMLAnchorElement = document.createElement<'a'>('a');
        element.download = 'errors.log';
        const textFile = window.URL.createObjectURL(data);
        element.href = textFile;
        element.click();
    }
}
